<!-- FOOTER -->
<div class="text-center text-muted small mt-4">
    © <span id="yr"></span> SwipFx • Secure FX Wallet & Matching
</div>

<script>
    document.getElementById('yr').textContent = new Date().getFullYear();
</script>